import { ValidationSchemaType } from 'hooks/useForm';
import { Promotion } from '../types/dtos';

export const PROMOTION_INITIAL_FIELDS: Promotion = {
    name: '',
    importance: '1000',
    type: 'REGULAR',
    page: 'HOME',
    startDate: null,
    endDate: null,
};

export const PROMOTION_FIELDS_SCHEMA: ValidationSchemaType<Promotion> = {
    name: {
        required: true,
        maxLength: 100,
    },
    importance: {
        required: true,
    },
    type: {
        required: true,
    },
    page: {
        required: true,
    },
};
